import React from 'react';
import {translate} from 'utils/common';
import SelectField from 'components/common/selectfield';
import GroupSearchV2 from 'common/groupSearchV2';
import MultiSelect from 'components/common/multiselect';
class FilterField extends React.Component {
    constructor(props){
        super(props);
        this.filterCbChanged = this.filterCbChanged.bind(this);
        this.filterMultiselectChanged = this.filterMultiselectChanged.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.state = {isLoading: true, filterFields: [], filterValue: this.props.value};
    }
    filterMultiselectChanged(e){
        this.setState({ filterValue: e.target.value },()=>{
            this.props.onChange({target:{value:e.target.value}})
        });
    }
    filterCbChanged(e){
        // this.setState({ filterValue: e.currentTarget.value },()=>{
        this.setState({ filterValue: e.target.value },()=>{
            //app.events.trigger(UI_FILTER_CHANGED, this.props.field, e.currentTarget.value);  
            if(this.props.onChange) {
                if (this.props.isDropDownRequired) {
                    this.props.onChange([e.target.type || this.props.field, e.target.value, this.props.fieldUniqkey])
                } else {
                    this.props.onChange(e.target.value)
                }
            }
        });
    }
    onInputChange(data) {
        this.setState({
            filterValue: data
        });
    }
    // processData(data){
    //     //Fix for 'all categories' translation
    //     if(data["rowData"] && data["rowData"][0].name) data["rowData"][0].name = translate(data["rowData"][0].name)
    //     return data;
    // }
    componentDidMount(){
        this.setState({filterFields: this.props.data});
        
        // if(this.props.data){
        // }else {
        //     dataservice.getRequest(this.props.requestType, {}).then(data => {
        //         this.processData(data);
        //         this.setState({filterFields: data ? data.rowData : {}});
        //     });
        // }        
    }
    resetInput() {
        this.setState({
            filterValue: ''
        });
    }
    renderByType(){
        const { filterFields, filterValue } = this.state;
        const options = filterFields;

        const prependSelectValue = this.props.prependSelectValue!=undefined? this.props.prependSelectValue:true
        switch(this.props.type){
            case 'groupsearch': 
                return <GroupSearchV2 options={options} placeholder={translate('search')} onInputChange={this.onInputChange}
                                      onChange={this.filterCbChanged} isDropDownRequired={this.props.isDropDownRequired} value={filterValue} />
            case 'multiselect': 
                return <MultiSelect onChange={this.filterMultiselectChanged} options={options}
                        value={this.props.defaultValue || []} />
                // <GroupSearchV2 options={options} placeholder={translate('search')} onInputChange={this.onInputChange}
                //                       onChange={this.filterCbChanged} isDropDownRequired={this.props.isDropDownRequired} value={filterValue} />
            default: return <SelectField prependSelectValue={prependSelectValue} onChange={this.filterCbChanged} 
                                         options={options} defaultValue={this.props.defaultValue || null} />
        }
    }    
    render(){
        const {filterFields} =this.state;
        const {isDropDownRequired} = this.props;
        return(
            <div className={"search-by-category "+ (this.props.className || '')}>
                <form className="form-inline">
                    <div className="form-group" style={{width:"100%"}}>
                        {(isDropDownRequired && filterFields && filterFields.length > 0 ||
                         !isDropDownRequired) && 
                            <React.Fragment>
                                {!this.props.hideLabel && <label>{this.props.label ? this.props.label: translate('filterby')}: </label>}
                                {this.renderByType()}
                            </React.Fragment>
                        }
                    </div>
                </form>            
            </div>
        )        
    }
}

FilterField.defaultProps = {
    isDropDownRequired: true,
    data: [],
    value: ''
}
export default FilterField;